// pages/leaves/calendar.tsx
import React from "react";
import { useAuth } from "@/hooks/useAuth";
import LeaveDashboard from "@/components/LeaveDashboard";
import { CalendarDays } from "lucide-react";

const LeaveCalendarPage: React.FC = () => {
  const { user } = useAuth();

  const canViewLeaves = [
    "admin",
    "hr_manager",
    "hr_staff",
    "manager",
    "employee",
  ].includes(user?.role || "");

  if (!canViewLeaves) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="text-center">
          <div className="h-12 w-12 mx-auto bg-indigo-50 dark:bg-indigo-900/20 rounded-full flex items-center justify-center mb-3">
            <CalendarDays className="text-indigo-600 dark:text-indigo-400 h-5 w-5" />
          </div>
          <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-1">Access Denied</h3>
          <p className="text-xs text-gray-600 dark:text-gray-400">
            You don't have permission to access leave calendar.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto space-y-5">
      {/* Page Header */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-3 mb-4 lg:mb-0">
          <div className="h-10 w-10 flex items-center justify-center rounded-lg bg-indigo-50 dark:bg-indigo-900/20">
            <CalendarDays className="h-5 w-5 text-indigo-600 dark:text-indigo-400" />
          </div>
          <div>
            <h1 className="text-lg font-semibold text-gray-900 dark:text-white">Leave Calendar</h1>
            <p className="text-gray-500 dark:text-gray-400 text-xs">
              View and manage all leave requests in calendar view
            </p>
          </div>
        </div>
      </div>

      {/* Calendar Content */}
      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-card overflow-hidden">
        <LeaveDashboard />
      </div>
    </div>
  );
};

export default LeaveCalendarPage;